import { __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { useMemo } from 'react';
import classNames from 'classnames';
import '../styles/index.less.js';

var Tag = function Tag(props) {
  var _a, _b, _c, _d;
  var title = props.title,
    color = props.color,
    _e = props.textColor,
    textColor = _e === void 0 ? '#fff' : _e,
    _f = props.type,
    type = _f === void 0 ? 'default' : _f,
    _g = props.lightBackground,
    lightBackground = _g === void 0 ? false : _g,
    _h = props.size,
    size = _h === void 0 ? 'middle' : _h,
    className = props.className,
    _j = props.style,
    style = _j === void 0 ? {} : _j;
  var styles = useMemo(function () {
    var theme = __assign(__assign({}, style), {
      '--ti-tag-primary-color': color,
      '--ti-tag-text-color': textColor
    });
    if (lightBackground) {
      theme.color = color;
    }
    return theme;
  }, [color, type, textColor]);
  if (type === 'default') {
    var mergeCls = classNames(className, (_a = {
      'ti-tag-default': true,
      'ti-tag-bg-light': lightBackground
    }, _a["ti-tag-default-".concat(size)] = true, _a));
    return /*#__PURE__*/React.createElement("span", {
      style: styles,
      className: mergeCls
    }, title);
  }
  if (type === 'left-round') {
    var mergeCls = classNames(className, (_b = {
      'ti-tag-left-round': true,
      'ti-tag-bg-light': lightBackground
    }, _b["ti-tag-left-round-".concat(size)] = true, _b));
    return /*#__PURE__*/React.createElement("span", {
      style: styles,
      className: mergeCls
    }, title);
  }
  if (type === 'outline') {
    var mergeCls = classNames(className, (_c = {
      'ti-tag-outline': true
    }, _c["ti-tag-outline-".concat(size)] = true, _c));
    return /*#__PURE__*/React.createElement("span", {
      style: styles,
      className: mergeCls
    }, title);
  }
  if (type === 'left-sharp') {
    var mergeCls = classNames(className, (_d = {
      'ti-tag-left-sharp': true
    }, _d["ti-tag-left-sharp-".concat(size)] = true, _d));
    return /*#__PURE__*/React.createElement("span", {
      style: styles,
      className: mergeCls
    }, /*#__PURE__*/React.createElement("span", {
      className: "ti-tag-left-sharp-content-".concat(size)
    }, title));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export { Tag as default };
